/**
 * /frontend/src/features/analytics/hooks/useOfferAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getOfferByAudience, getOfferComparison, getOfferSummary } from '../api/offerAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads offer analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useOfferAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [summary, comparison, byAudience] = await Promise.all([
      getOfferSummary(request, storeToken, storeUuid, startDate, endDate),
      getOfferComparison(request, storeToken, storeUuid, startDate, endDate),
      getOfferByAudience(request, storeToken, storeUuid, startDate, endDate),
    ]);
    return { summary, comparison, byAudience };
  }, [endDate, request, startDate, storeToken, storeUuid]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useOfferAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useOfferAnalytics;
